<template>
	<div class="p-3">
		<img v-if="timeLeftPrecent >= 90"	class="timer" src="@/assets/images/skill-assessment/icons/timer/clock_loader_90.svg" />
		<img v-else-if="timeLeftPrecent >= 80"	class="timer" src="@/assets/images/skill-assessment/icons/timer/clock_loader_80.svg" />
		<img v-else-if="timeLeftPrecent >= 60"	class="timer" src="@/assets/images/skill-assessment/icons/timer/clock_loader_60.svg" />
		<img v-else-if="timeLeftPrecent >= 40"	class="timer" src="@/assets/images/skill-assessment/icons/timer/clock_loader_40.svg" />
		<img v-else-if="timeLeftPrecent >= 20"	class="timer" src="@/assets/images/skill-assessment/icons/timer/clock_loader_20.svg" />
		<img v-else	class="timer" src="@/assets/images/skill-assessment/icons/timer/clock_loader_10.svg"/>
		Time left: {{ timeLeft }}
	</div>
	<hr class="mt-0 mb-2" />
</template>

<script lang="ts">
import { QuizGetters } from '@/store/modules/quiz/getters'
import { STATE_MODULES } from '@/store/state-modules'
import { defineComponent } from 'vue'
import moment from 'moment';
import { QuizActions } from '@/store/modules/quiz/actions';

const UPDATE_RATE = 1000;

export default defineComponent({
	data () : any {
		return {
			interval: null as ReturnType<typeof setInterval> | null,
			time: 0
		}
	},
	computed: {
		timeLeft () {
			return moment.utc(this.time).format('HH:mm:ss');
		},
		timeLeftPrecent () {
			try {
				const timeTotal: number = ((this.$store.getters[`${STATE_MODULES.QUIZ}/${QuizGetters.GET_QUIZ_TIME}`] || 1) * 60 * 1000) || 1;
				const currentTime = this.time || 1;
				return parseInt(((currentTime / timeTotal) * 100).toFixed(0));	
			} catch (error) {
				return 50
			}
		}
	},
	methods: {
		tickClock () {
			this.time = Math.max(this.time - UPDATE_RATE, 0);
			if (this.time === 0) {
				this.$store.dispatch(`${STATE_MODULES.QUIZ}/${QuizActions.EXPIRE_QUIZ}`)
			}
		}
	},
	mounted () {
		this.time = this.$store.getters[`${STATE_MODULES.QUIZ}/${QuizGetters.GET_TIME_LEFT}`];
		this.interval = setInterval(this.tickClock, UPDATE_RATE);
	},
	watch: {
		originalTime (oldTime: number, newTime: number) {
			if (oldTime !== newTime) {
				this.time = newTime;
			}
		}
	},
	unmounted () {
		if (this.interval) {
			clearInterval(this.interval)
		}
	}
})
</script>

<style scoped>
	hr {
		background: #DADBDD;
	}
	.timer{
		vertical-align: bottom;
	}
</style>
